module.exports = __webpack_public_path__ + "static/media/team1.d6c3bb1c.png";